import React from "react";
import axios from "../util/Api";
import "antd/dist/antd.css";
import { message, Spin } from "antd";
import { tokensKey } from "../util/Constants";
import getStorage from "../context/auth";
import { round } from "lodash";

class BillsDivider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bills: [],
            identifier: null,
            total: 0,
            isLoading: false,
        };
    }

    componentDidMount() {
        this.checkProps();
    }

    componentDidUpdate() {
        this.checkProps();
    }

    checkProps() {
        if (this.props.identifier !== this.state.identifier) {
            this.setState({
                identifier: this.props.identifier,
                total: this.props.weight || 0,
                bills: [],
            });
        }
    }

    handleNameChange = (index, e) => {
        const value = e.target.value;
        this.setState(prevState => {
            const bills = [...prevState.bills];
            bills[index] = { ...bills[index], name: value };
            return { bills };
        });
    };

    handleMarchandiseChange = (index, e) => {
        const value = e.target.value;
        this.setState(prevState => {
            const bills = [...prevState.bills];
            bills[index] = { ...bills[index], marchandise: value };
            return { bills };
        });
    };

    handleValueChange = (index, e) => {
        const value = e.target.value;
        this.setState(prevState => {
            const bills = [...prevState.bills];
            bills[index] = { ...bills[index], weight: value };
            return { bills };
        });
    };

    handleAddingLot = (e) => {
        e.preventDefault();
        this.setState((prevState) => ({
            bills: [
                ...prevState.bills,
                { name: "", marchandise: "", weight: 0.0 },
            ],
        }));
    };

    handleRemovingLot = (index, e) => {
        e.preventDefault();
        this.setState((prevState) => ({
            bills: prevState.bills.filter((_, i) => i !== index),
        }));
    };

    handleLotConfirmation = () => {
        const { bills, identifier, total } = this.state;
        // Compute total bills weight safely (handling commas and non-numeric values)
        const totalBills = round(
            bills.reduce((acc, { weight }) => {
                const parsed = parseFloat(weight.toString().replace(",", "."));
                return acc + (isNaN(parsed) ? 0 : parsed);
            }, 0),
            2
        );
        const totalNumber = parseFloat(total) || 0;
        console.log("Computed totalBills:", totalBills);
        console.log("Expected total (totalNumber):", totalNumber);

        if (Math.abs(totalBills - totalNumber) > 0.01) {
            message.error({
                content: "Il faut que la somme des poids soit égale au tonnage total",
                className: "custom-class",
                style: { marginTop: "20vh" },
            });
            return;
        }

        const { jwt } = JSON.parse(getStorage().getItem(tokensKey));
        if (jwt) {
            this.setState({ isLoading: true });
            axios
                .post(
                    `api/bons-decoupe/custom-create`,
                    {
                        bons: bills.map((bill) => {
                            const obj = {
                                reference: bill.name,
                                weight: bill.weight,
                            };
                            if (bill.marchandise && bill.marchandise.trim() !== "") {
                                obj.marchandise = bill.marchandise;
                            }
                            return obj;
                        }),
                        measure: identifier,
                    },
                    { headers: { Authorization: `Bearer ${jwt}` } }
                )
                .then((result) => {
                    if (result.status === 200) {
                        message.success({
                            content: "Découpage effectué avec succès",
                        });
                        this.setState({ isLoading: false });
                        this.props.onUpdated();
                    }
                })
                .catch((e) => {
                    this.setState({ isLoading: false });
                    console.error("Error", e);
                    message.error({
                        content: "Une erreur est survenue",
                    });
                });
        }
    };

    render() {
        const { bills, total, isLoading } = this.state;
        const totalNumber = parseFloat(total) || 0;
        const totalBills = round(
            bills.reduce((acc, { weight }) => {
                const parsed = parseFloat(weight.toString().replace(",", "."));
                return acc + (isNaN(parsed) ? 0 : parsed);
            }, 0),
            2
        );

        return (
            <div className="col mt-4 pt-2">
                <div className="component-wrapper rounded shadow">
                    <div className="p-4 border-bottom">
                        <h4 className="title mb-0">Découpage de la mesure</h4>
                        <p>
                            La totalité est {totalNumber.toFixed(2)} et il vous reste{" "}
                            {(totalNumber - totalBills).toFixed(2)} tonnes à decouper
                        </p>
                    </div>
                    <div className="p-4">
                        <form>
                            {bills.map((billElement, index) => (
                                <div className="row" key={index}>
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className="form-icon position-relative">
                                                <i
                                                    data-feather="user"
                                                    className="fea icon-sm icons"
                                                />
                                                <input
                                                    name="name"
                                                    id="name"
                                                    type="text"
                                                    className="form-control ps-3"
                                                    placeholder={`Référence lot : ${index + 1}`}
                                                    value={billElement.name}
                                                    onChange={(e) => this.handleNameChange(index, e)}
                                                />
                                            </div>
                                            <small className="text-muted d-block mt-1">
                                                Mention obligatoire: indiquez la référence du lot avant de générer le document.
                                            </small>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className="form-icon position-relative">
                                                <i
                                                    data-feather="layers"
                                                    className="fea icon-sm icons"
                                                />
                                                <input
                                                    name="marchandise"
                                                    id="marchandise"
                                                    type="text"
                                                    className="form-control ps-3"
                                                    placeholder="Marchandise (optionnel)"
                                                    value={billElement.marchandise}
                                                    onChange={(e) =>
                                                        this.handleMarchandiseChange(index, e)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="mb-3">
                                            <div className="form-icon position-relative">
                                                <i
                                                    data-feather="mail"
                                                    className="fea icon-sm icons"
                                                />
                                                <input
                                                    name="weight"
                                                    id="weight"
                                                    type="number"
                                                    min="0"
                                                    autoComplete="off"
                                                    className="form-control ps-3"
                                                    placeholder={`Tonnage lot : ${index + 1}`}
                                                    value={billElement.weight}
                                                    onChange={(e) => this.handleValueChange(index, e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <input
                                            readOnly
                                            id="submit"
                                            name="send"
                                            className="btn btn-outline-secondary btn-sm"
                                            value="Supprimer"
                                            onClick={(e) => this.handleRemovingLot(index, e)}
                                        />
                                    </div>
                                </div>
                            ))}
                            <div className="row">
                                <div className="col-sm-12">
                                    <input
                                        id="submit"
                                        name="send"
                                        className="btn btn-secondary"
                                        value="Ajouter un lot"
                                        onClick={(e) => this.handleAddingLot(e)}
                                    />
                                </div>
                            </div>
                        </form>
                        <div
                            className="row border-top"
                            style={{ marginTop: 25, paddingTop: 25 }}
                        >
                            <div className="col-sm-12">
                                <a
                                    className="btn btn-primary"
                                    onClick={() => {
                                        if (!isLoading) this.handleLotConfirmation();
                                    }}
                                    style={{ width: "100%" }}
                                >
                                    {isLoading ? <Spin /> : "Confirmer changement"}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default BillsDivider;
